import React, { useState } from 'react';
import { Plus, Search, Mail, Phone, MapPin, Award } from 'lucide-react';
const teamMembers = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Senior Sales Manager',
  email: 'marco.rossi@edares.com',
  phone: '+39 02 1234 5678',
  location: 'Milano',
  activeDeals: 8,
  closedDeals: 23,
  totalRevenue: 580000,
  performance: 95,
  joinDate: 'Gen 2020',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'Sales Manager',
  email: 'laura.bianchi@edares.com',
  phone: '+39 02 2345 6789',
  location: 'Milano',
  activeDeals: 6,
  closedDeals: 19,
  totalRevenue: 520000,
  performance: 92,
  joinDate: 'Mar 2020',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
}, {
  id: 3,
  name: 'Giuseppe Verdi',
  role: 'Sales Manager',
  email: 'giuseppe.verdi@edares.com',
  phone: '+39 02 3456 7890',
  location: 'Milano',
  activeDeals: 7,
  closedDeals: 17,
  totalRevenue: 480000,
  performance: 88,
  joinDate: 'Giu 2020',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop'
}, {
  id: 4,
  name: 'Sofia Romano',
  role: 'Junior Sales Manager',
  email: 'sofia.romano@edares.com',
  phone: '+39 02 4567 8901',
  location: 'Milano',
  activeDeals: 5,
  closedDeals: 15,
  totalRevenue: 420000,
  performance: 85,
  joinDate: 'Set 2021',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
}, {
  id: 5,
  name: 'Andrea Ferrari',
  role: 'Junior Sales Manager',
  email: 'andrea.ferrari@edares.com',
  phone: '+39 02 5678 9012',
  location: 'Milano',
  activeDeals: 4,
  closedDeals: 12,
  totalRevenue: 380000,
  performance: 82,
  joinDate: 'Gen 2022',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
}];
export function TeamMembers() {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredMembers = teamMembers.filter(member => member.name.toLowerCase().includes(searchQuery.toLowerCase()) || member.role.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-3038">
      <div className="flex items-center justify-between" data-id="element-3039">
        <div data-id="element-3040">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-3041">
            Membri del Team
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-3042">
            Gestisci e monitora il tuo team di vendita
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal hover:bg-[#0f6b8a] transition-colors rounded-full" data-id="element-3043">
          <Plus className="w-4 h-4" data-id="element-3044" />
          Aggiungi Membro
        </button>
      </div>
      {/* Search Bar */}
      <div className="bg-white border border-gray-200 p-4 rounded-lg" data-id="element-3045">
        <div className="relative" data-id="element-3046">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-3047" />
          <input type="text" placeholder="Cerca membri del team..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-3048" />
        </div>
      </div>
      {/* Members Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3049">
        {filteredMembers.map(member => <div key={member.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow" data-id="element-3050">
            <div className="p-6" data-id="element-3051">
              <div className="flex items-start justify-between mb-4" data-id="element-3052">
                <img src={member.avatar} alt={member.name} className="w-16 h-16 rounded-full object-cover" data-id="element-3053" />
                <div className="flex items-center gap-1 px-2 py-1 bg-[#1388ad]/10 rounded-full" data-id="element-3054">
                  <Award className="w-3 h-3 text-[#1388ad]" data-id="element-3055" />
                  <span className="text-xs font-semibold text-[#1388ad]" data-id="element-3056">
                    {member.performance}%
                  </span>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-3057">
                {member.name}
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-3058">{member.role}</p>
              <div className="space-y-2 mb-4" data-id="element-3059">
                <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-3060">
                  <Mail className="w-4 h-4 text-gray-400" data-id="element-3061" />
                  <span className="truncate" data-id="element-3062">{member.email}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-3063">
                  <Phone className="w-4 h-4 text-gray-400" data-id="element-3064" />
                  <span data-id="element-3065">{member.phone}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-3066">
                  <MapPin className="w-4 h-4 text-gray-400" data-id="element-3067" />
                  <span data-id="element-3068">{member.location}</span>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200" data-id="element-3069">
                <div data-id="element-3070">
                  <p className="text-xs text-gray-500" data-id="element-3071">Trattative Attive</p>
                  <p className="text-lg font-semibold text-gray-900" data-id="element-3072">
                    {member.activeDeals}
                  </p>
                </div>
                <div data-id="element-3073">
                  <p className="text-xs text-gray-500" data-id="element-3074">Chiuse</p>
                  <p className="text-lg font-semibold text-gray-900" data-id="element-3075">
                    {member.closedDeals}
                  </p>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-3076">
                <p className="text-xs text-gray-500 mb-1" data-id="element-3077">Revenue Totale</p>
                <p className="text-xl font-semibold text-[#1388ad]" data-id="element-3078">
                  €{(member.totalRevenue / 1000).toFixed(0)}K
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}